import { render, staticRenderFns } from "./LandAgreement.vue?vue&type=template&id=05dce7a1"
import script from "./LandAgreement.vue?vue&type=script&lang=js"
export * from "./LandAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports